// extracted by mini-css-extract-plugin
export default {"discountBanner":"rfa","topheader":"sfa","navleft":"tfa","navflexelem":"ufa","navright":"vfa","fixedtop":"wfa","abstop":"xfa","subdesc":"yfa","smallscreennav":"zfa","nav_hidden":"Afa","cancel_link":"Bfa","bottomnavcontainer":"Cfa","fixedbottom":"Efa","animatedbottom":"Ffa","appear-bottom":"Gfa","delayedbottom":"Hfa","retakebtn":"Ifa","long_banner":"Jfa","nofixed":"Kfa"};
    if(module.hot) {
      // 1737143665398
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  